export default __webpack_public_path__ + "static/intergations-presentation-1ab5b7063d0e5c5941e8219403db2ecb.png";